import React from 'react';
import Page from '@/components/Page';

export default function HomePage() {
	return (
    	<Page title='Главная'>
	    </Page>
  	);
}
